import { useTranslation } from "react-i18next"
import { ResourceContentSection } from "@/components/molecules/ResourceContentSection/ResourceContentSection"

export function PrivacyContent() {
  const { t } = useTranslation()

  const contentItems = [
    { type: "heading1" as const, content: t("privacy.introduction.title") },
    { type: "paragraph" as const, content: t("privacy.introduction.content") },

    { type: "heading1" as const, content: t("privacy.important.title") },
    { type: "heading2" as const, content: t("privacy.important.purpose.title") },
    { type: "paragraph" as const, content: t("privacy.important.purpose.content") },

    { type: "heading2" as const, content: t("privacy.important.controller.title") },
    { type: "paragraph" as const, content: t("privacy.important.controller.content") },

    { type: "heading2" as const, content: t("privacy.important.contact.title") },
    { type: "paragraph" as const, content: t("privacy.important.contact.content") },
    {
      type: "list" as const,
      content: [
        t("privacy.important.contact.entity"),
        t("privacy.important.contact.email"),
        t("privacy.important.contact.address"),
      ],
    },
    { type: "paragraph" as const, content: t("privacy.important.contact.complaint") },

    { type: "heading2" as const, content: t("privacy.data.title") },
    { type: "paragraph" as const, content: t("privacy.data.definition") },
    { type: "paragraph" as const, content: t("privacy.data.collection") },

    { type: "heading2" as const, content: t("privacy.data.types.title") },
    {
      type: "list" as const,
      content: [
        t("privacy.data.types.identity"),
        t("privacy.data.types.contact"),
        t("privacy.data.types.transaction"),
        t("privacy.data.types.usage"),
        t("privacy.data.types.marketing"),
      ],
    },

    { type: "heading2" as const, content: t("privacy.collection.title") },
    { type: "paragraph" as const, content: t("privacy.collection.content") },
    {
      type: "list" as const,
      content: [t("privacy.collection.direct"), t("privacy.collection.automated"), t("privacy.collection.third")],
    },

    { type: "heading2" as const, content: t("privacy.usage.title") },
    { type: "paragraph" as const, content: t("privacy.usage.content") },
    {
      type: "list" as const,
      content: [t("privacy.usage.contract"), t("privacy.usage.legitimate"), t("privacy.usage.legal")],
    },

    { type: "heading2" as const, content: t("privacy.security.title") },
    { type: "paragraph" as const, content: t("privacy.security.content") },

    { type: "heading2" as const, content: t("privacy.rights.title") },
    { type: "paragraph" as const, content: t("privacy.rights.content") },
    {
      type: "list" as const,
      content: [
        t("privacy.rights.access"),
        t("privacy.rights.correction"),
        t("privacy.rights.erasure"),
        t("privacy.rights.object"),
        t("privacy.rights.restriction"),
        t("privacy.rights.transfer"),
        t("privacy.rights.withdraw"),
      ],
    },
    { type: "paragraph" as const, content: t("privacy.rights.exercise") },
  ]

  return <ResourceContentSection items={contentItems} />
}
